import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cf878ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mel" }
const _hoisted_2 = { class: "mel__modal" }
const _hoisted_3 = { class: "mel__modal-close" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mel__modal-title" }, "Последние действия", -1))
const _hoisted_5 = { class: "mel__modal-content" }
const _hoisted_6 = { class: "mel__modal-content-wr" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"mel__modal-content-wr-th\" data-v-cf878ffa><div class=\"mel__modal-content-wr-th-head\" data-v-cf878ffa> Пользователь </div><div class=\"mel__modal-content-wr-th-head\" data-v-cf878ffa>Поле</div><div class=\"mel__modal-content-wr-th-head\" data-v-cf878ffa> Старое значение </div><div class=\"mel__modal-content-wr-th-head\" data-v-cf878ffa> Новое значение </div><div class=\"mel__modal-content-wr-th-head\" data-v-cf878ffa>Время</div></div>", 1)
const _hoisted_8 = { class: "mel__modal-content-wr-tb-body" }
const _hoisted_9 = { class: "mel__modal-content-wr-tb-body" }
const _hoisted_10 = { class: "mel__modal-content-wr-tb-body" }
const _hoisted_11 = { class: "mel__modal-content-wr-tb-body" }
const _hoisted_12 = { class: "mel__modal-content-wr-tb-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
      class: "mel__overlay"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconClose, {
          onClick: _ctx.onClose,
          class: "mel__modal-close-icon"
        }, null, 8, ["onClick"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventLog, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mel__modal-content-wr-tb",
              key: index
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.user_name), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.field), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.old_value), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.new_value), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.dataTimeFormat(item.update_stamp)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}